import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Search, Sparkles } from 'lucide-react';

type Props = { reason: string; canAsk: boolean; onClear: () => void; onAsk: () => void };

/** Says why nothing matched and offers the two ways forward: fewer filters, or ask the question instead. */
export function NoResults({ reason, canAsk, onClear, onAsk }: Props) {
  return (
    <Stack role="status" sx={boxSx}>
      <Box aria-hidden sx={{ width: 36, height: 36, borderRadius: 1.25, display: 'grid', placeItems: 'center', bgcolor: 'surface.sunken', color: 'text.secondary' }}>
        <Search size={16} />
      </Box>
      <Typography variant="h4" component="p" sx={{ mt: 1.5 }}>No reports match</Typography>
      <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5, maxWidth: 440 }}>{reason} Try removing a filter.</Typography>
      <Stack direction="row" sx={{ gap: 1, mt: 2.5, flexWrap: 'wrap', justifyContent: 'center' }}>
        <Button variant="outlined" onClick={onClear} sx={{ color: 'text.primary', borderColor: 'divider', bgcolor: 'background.paper' }}>Clear filters</Button>
        {canAsk ? <Button variant="contained" startIcon={<Sparkles size={14} />} onClick={onAsk}>Ask Research instead</Button> : null}
      </Stack>
    </Stack>
  );
}

const boxSx = {
  alignItems: 'center',
  textAlign: 'center',
  px: 3,
  py: { xs: 6, md: 8 },
  bgcolor: 'background.paper',
  border: 1,
  borderColor: 'divider',
  borderRadius: 1.5,
  '@keyframes noneIn': { from: { opacity: 0, transform: 'translateY(6px)' }, to: { opacity: 1, transform: 'none' } },
  animation: 'noneIn 260ms ease-out both',
  '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
} as const;
